/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryKeys } from "./queryKeys";

// Availability is cached for 5 minutes, so without this a second booking is offered the
// times the first one just took. Every mutation that occupies or frees a slot must call it.
export const invalidateAvailability = (queryClient) => {
  queryClient.invalidateQueries({ queryKey: queryKeys.timeslots.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.firstAvailableDay.all });
};
